module.exports = __webpack_public_path__ + "static/img/chair_kp_max.ee26c105.png";